import { useState } from "react";
import { Link } from "react-router-dom";
import { useAirdrops } from "../hooks/useAirdrops";
import { AirdropPicker } from "./AirdropPicker";
import { AirdropRecipientsTable } from "./AirdropRecipientsTable";
import { Skeleton } from "./Skeleton";

/**
 * Leaderboards tab: pick an airdrop and see its recipients ranked by $CARDS,
 * with a link to the full stats page.
 */
export function AirdropLeaderboard() {
  const airdropsQuery = useAirdrops();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const airdrops = airdropsQuery.data?.data ?? [];
  const activeId = selectedId ?? airdrops[0]?.id ?? null;

  if (airdropsQuery.isLoading) {
    return <Skeleton kind="table" rows={6} />;
  }

  if (airdropsQuery.error) {
    return (
      <p className="text-red-400">
        Could not load airdrops: {String(airdropsQuery.error)}
      </p>
    );
  }

  if (airdrops.length === 0) {
    return (
      <p className="text-gray-500 py-4">
        No $CARDS airdrops are being tracked yet.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <AirdropPicker airdrops={airdrops} activeId={activeId} onChange={setSelectedId} />
        <Link
          to="/airdrops"
          className="text-sm text-blue-400 hover:text-blue-300"
        >
          Full airdrop stats
        </Link>
      </div>

      {activeId && <AirdropRecipientsTable airdropId={activeId} />}
    </div>
  );
}
